/** The potential jobs.
 * Keep in sync with the [EnumMember(Value = "Some Descriptive Value")] of the
 * corresponding JobType enum in Omnius.Custom.Framework.Jobs (V1) or Omnius.Custom.Common\Enumerations\Jobs\JobType.cs (V2)
 *
 * If job or export enums are needed to be ran or displayed in V1 then all properties should be updated in Omnius.Framework/Jobs/JobType.cs,
 * otherwise V1 updates can be skipped.
 */
enum JobType {
  NYSDOHProject = "NYSDOH Project",
  ProviderSetGeocode = "ProviderSet Geocode",
  StandardizeNames = "ProviderSet Name Standardization",
  CACDIProject = "CACDI Project",
  CADMHCProject = "CADMHC Project",
  NJDOBIProject = "NJDOBI Project",
  UpdateDeacNPIs = "Update Deactivated NPIs",
  NYSDOHMarket = "NYSDOH Market Analysis",
  NYSDOHRunProjects = "NYSDOH Run Projects",
  NYSDOHMarketDataExtract = "NYSDOH Market Data Extract",
  NJDOBIMarket = "NJDOBI Market",
  NJDOBIRunProjects = "NJDOBI Run Projects",
  NJDOBIMarketDataExtract = "NJDOBI Market Data Extract",
  DailyStatsEmail = "Send Daily Stats Email",
  DeletePurgedProjects = "Delete Purged Projects",
  NYSDOHCreateSpecialtyBridgeTable = "NYSDOH Create Specialty Bridge",
  AmeritasFileImport = "Ameritas File Import",
  AmeritasIndexUpdate = "Ameritas Index Update",
  GenerateMADownloadReport = "Generate Download Report",
  ReportNotification = "Download Report Notification",
  PurgeOldReports = "Purge Old Reports",
  GenerateNYSDOHDownloadReport = "Generate NYSDOH Download Report",
  GenerateNJDOBIDownloadReport = "Generate NJDOBI Download Report",
  GenerateCACDIDownloadReport = "Generate CACDI Download Report",
  GenerateCADMHCDownloadReport = "Generate CADMHC Download Report",
  ProviderSetFormat = "Provider Set Format",
  NYSDOHDownstreamProject = "NYSDOH Downstream Project",
  ProviderSetConversion = "Provider Set Conversion",
  NJDOBIDownstreamProject = "NJDOBI Downstream Project",
  NYSDOHPopulateSpecialtyBridge = "NYSDOH Populate Specialty Bridge",
  NYSDOHDownstreamPopulateSpecialtyBridge = "NYSDOH Downstream Populate Specialty Bridge",
  NJDMAHSProject = "NJDMAHS Project",
  GenerateNJDMAHSDownloadReport = "Generate NJDMAHS Download Report",
  ReviseProjects = "Revise Projects",
  PublishProject = "Publish Project",
  CreateProviderSetIndexes = "Create ProviderSet Indexes",
  CustomAdequacyProject = "Custom Adequacy",
  CustomAdequacyRegionSummary = "Custom Adequacy Region Summary",
  CustomAdequacyProjectReaggregation = "Custom Adequacy Project Reaggregation",
  CustomNetworkSummariesProject = "Custom Network Summaries",
  CustomMemberCensusBlowout = "Custom Member Census Blowout",
  Export = "Export",
  NetworkAccuracyAnalysis = "Network Accuracy Analysis",
  Import = "Import",
  SaveClientGapLinks = "Save Client Gap Links",
  ProcessProviderChanges = "Process Provider Changes",
  SpecialtyGroupExceptionAnalysis = "Specialty Group Exception Analysis",
  QESIProviderUpload = "QESI Provider Upload",
  ProviderChangesRegionSummary = "Provider Changes Region Summary",
  BulkProviderTermination = "Volume Provider Termination",
  AccessReport = "Access Report",
  ProspectMarketNcp = "Prospect/Market Next Closest Provider",
  ProspectMarketNcpRegion = "Prospect/Market Next Closest Provider Region",
  AccuracyGapAnalysis = "Accuracy Gap Analysis",
  BulkTarget = "Volume Target",
  AccessReportEmployeeUpload = "Access Report Employee File Upload",
  AccessReportProviderSetCopy = "Access Report Provider Set Copy",
  MipsDataManagement = "MIPS Import and Data Management",
  PcaDataManagement = "PCA Import and Data Management",
  ValidNPIDataManagement = "Valid NPI Import and Data Management",
  VolumeExport = "Volume Export",
  AccessReportFileShareMaint = "Access Report File Share Maint",
  AccuracyGapAnalysisRegionSummaryJob = "Accuracy Gap Analysis Region Summary Job",
  AccuracyGapAnalysisAggregationJob = "Accuracy Gap Analysis Aggregation Job",
  LocationConfidenceScoresDataManagement = "Location Confidence Scores Import and Data Management",
  CustomCreateProviderSetIndexes = "Custom Create ProviderSet Indexes",
  EnterpriseComplianceDashboard = "Enterprise Compliance Dashboard",
  SimulateNoHeartbeatJob = "Simulate No Heartbeat Job",
  SimulateZombieJob = "Simulate Zombie Job",
  PciDashboardTablePublish = "Provider Claims Insights Dashboard Table Publish",
  AccuracyAggregation = "Accuracy Aggregation",
  ProjectPublishBackgroundJob = "Project Publish Background Job",
  SimulateOutOfMemoryJob = "Simulate Out of Memory Job",
  ZipCodeAnalysisProjectRunConfigurationJob = "Zip Code Analysis Project Run Configuration Job",
  ZipCodeAnalysisFinalizerJob = "Zip Code Analysis Finalizer Job",
  ZipCodeAnalysisRegionJob = "Zip Code Analysis Region Job",
  MotiveScoresDataManagement = "Motive Scores Import and Data Management",
  NetworkBenchmarkingCmsDataIngestion = "Network Benchmarking CMS Data Ingestion",
  CISupersetProviderContractIngestion = "CI Superset Provider Contract Ingestion",
  NetworkBenchmarkingPciDataIngestion = "Network Benchmarking PCI Data Ingestion",
  CustomCreateProviderSetVersionSummary = "Create Provider Set Version Summary Job",
  NetworkBenchmarkingServicingProviderIngestion = "Network Benchmarking Servicing Provider Ingestion",
  NetworkBenchmarkingServicingProviderSplit = "Network Benchmarking Servicing Provider Split",
  ZipClassAggregateJob = "Zip Class Aggregate Job",
  ZipCodeGeographyJob = "Zip Code Geography Job",
  ZipCodeAnalysisCleanExpiredStagingTablesJob = "Zip Code Analysis Clean Expired Staging Tables Job",
  LocationConfidenceScoresActivate = "Location Confidence Scores Activate Version",
  LocationConfidenceScoresDeactivate = "Location Confidence Scores Deactivate Version",
  PcaDataActivate = "PCA Data Activate Version",
  PcaDataDeactivate = "PCA Data Deactivate Version",
  MipsDataActivate = "MIPS Data Activate Version",
  MipsDataDeactivate = "MIPS Data Deactivate Version",
  MotiveScoresActivate = "Motive Scores Activate Version",
  MotiveScoresDeactivate = "Motive Scores Deactivate Version",
  ValidNPIDataActivate = "Valid NPI Activate Version",
  ValidNPIDataDeactivate = "Valid NPI Deactivate Version",
  SpecialtyGroupDataSync = "Specialty Group Data Sync",
  ProviderValidation = "Provider Validation",
  AccuracySummaryAggregation = "Accuracy Summary Aggregation",
  ECDPurgeData = "ECD Purge Data",
  CareJourneyScoresDataManagement = "CareJourney Scores Data Management",
  JobsPurgeData = "Jobs Purge Data",
  ProviderAffiliationVersion = "Provider Affiliation Version",
  EcdRunConfigurationsPublished = "ECD Run Configurations Published",
  CustomArchiveProviderSets = "Archive Provider Sets",
  ZipAnalysisNcpRegionJob = "Zip Analysis Next Closest Providers Region Job",
  ZipAnalysisNcpRunConfigurationJob = "Zip Analysis Next Closest Providers Run Configuration Job",
  ZipCodeProviderChangesRunConfiguration = "Zip Code Provider Changes Run Configuration",
  ZipCodeProviderChangesRegion = "Zip Code Provider Changes Region Job",
  ProviderValidationCoordination = "Provider Validation Coordination Job",
  BatchedProviderValidation = "Batched Provider Validation Job",
  CiProviderContractEntityIngestion = "Competitive Insights Provider Contract Entity Ingestion",
  ProviderSetVersionParquetCopy = "Provider Set Version Parquet Copy",
  ServicingProvidersVolumeExport = "Servicing Providers Volume Export",
  NetworkIntegrityProspectProvider = "Network Integrity Prospect Provider",
  NetworkIntegrityNetworkProvider = "Network Integrity Network Provider",
  NetworkIntegrityServicingProvider = "Network Integrity Servicing Provider",
  NetworkIntegrityNetworkAggregate = "Network Integrity Network Aggregate",
  NetworkIntegrityProspectAggregate = "Network Integrity Prospect Aggregate",
  NetworkIntegrityServicingAggregate = "Network Integrity Servicing Aggregate",
  CustomDiffProviderSetConversion = "Custom Diff Provider Set Conversion",
  VolumeProviderExclusions = "Volume Provider Exclusions",
  GapSharedInsights = "Gap Shared Insights",
  ProviderSetIngestion = "Provider Set Ingestion",
  ServicingProviderSnowflakeIngestion = "Servicing Provider Snowflake Ingestion",
  NetworkIntegrityProspectServicingProvider = "Network Integrity Prospect Servicing Provider",
  NetworkIntegrityProspectServicingAggregate = "Network Integrity Prospect Servicing Aggregate",
  ProviderChangesAggregateJob = "Provider Changes Aggregate Job",
  TaxonomyPredictionDataManagementJob = "Taxonomy Prediction Data Management Job",
  ConvertDataFromMongoToSnowflakeJob = "Convert Data From Mongo To Snowflake Job",
  MedicareMarketOpportunityDataMgmtJob = "Medicare Market Opportunity Data Management Job",
  AhdDataIngestionJob = "AHD Data Ingestion",
  ProviderMarketDataManagementJob = "Provider Market Data Management Job",
  ActivateProviderSetVersionJob = "Activate Provider Set Version Job",
  IngestDefactoSuperset = "Ingest Defacto Superset to Snowflake",
  ExecuteSupersetRun = "Execute Superset Run Job",
  NppesDataManagement = "NPPES Data Management Job",
  NetworkIntegrityMarketProvider = "Network Integrity Market Provider",
  SnowflakeTimeAndDistance = "Calculate Time and Distance in Snowflake",
  NetworkIntegrityServicingMarketProvider = "Network Integrity Servicing Market Provider",
  ProviderValidationSnowflakeIngestion = "Ingest SQL Provider Validation Data Into Snowflake",
  BulkZipTarget = "Bulk Zip Volume Target",
  SnowflakeServicing = "Calculate Servicing in Snowflake",
  SnowflakeAccessCalculation = "Calculate Access in Snowflake",
  SnowflakeDataShareRefresh = "Snowflake Data Share Refresh",
  MergeSnowflakeTimeAndDistanceCacheToClient = "Merge Snowflake Time and Distance Cache to Client",
  MergeSnowflakeTimeAndDistanceCacheToCore = "Merge Snowflake Time and Distance Cache to Core",
  MarketplaceMarketOpportunityDataManagementJob = "Marketplace Market Opportunity Data Management Job",
  AccuracySnowflakeIngestion = "Accuracy Snowflake Ingestion",
  AdequacyNetworkSummaryBackfill = "Adequacy Network Summary Backfill",
  BulkZipTermination = "Bulk Zip Volume Termination",
  PgrDataManagementJob = "PGR Data Management Job",
  MedicaidMarketOpportunityDataManagementJob = "Medicaid Market Opportunity Data Management Job",
  SnowflakeDataShareViewExport = "Snowflake Data Share View Export",
  SnowflakeDataShareCleanup = "Snowflake Data Share Cleanup",
  BulkZipFinalizeRunConfiguration = "Bulk Zip Finalize Run Configuration",
  ReportPurge = "Report Purge",
  AdequacyProjectRunParquetRetention = "Adequacy Project Run Parquet Retention",
  MemberSetIngestion = "Member Set Ingestion",
}

export { JobType };